// Builds Dashboard tab list, resolves active tab, and wires URL-driven tab effects.
import { useMemo } from 'react';
import { buildDashTabs } from '@/features/dashboard/utils/dashboardPageUtils';
import {
  useDashboardTabEffects,
  TAB_COMPLETED,
} from '@/features/dashboard/hooks/use-dashboard-tab-effects';

export function useDashboardTabs({
  isBattlefield,
  t,
  waitingCount,
  completedCount,
  dashTab,
  setDashTab,
  searchParams,
}) {
  const dashTabs = useMemo(
    () => buildDashTabs(isBattlefield, t, waitingCount, completedCount),
    [isBattlefield, t, waitingCount, completedCount],
  );

  const activeTabId = dashTabs[dashTab]?.id ?? TAB_COMPLETED;
  const completedTabIndex = dashTabs.findIndex(
    (tab) => tab.id === TAB_COMPLETED,
  );
  const waitingTabIndex = dashTabs.findIndex((tab) => tab.id === 'waiting');

  useDashboardTabEffects({
    searchParams,
    waitingTabIndex,
    isBattlefield,
    waitingCount,
    activeTabId,
    completedTabIndex,
    setDashTab,
  });

  return { dashTabs, activeTabId, completedTabIndex };
}
